<div class="row px-3">
  <div class="col-12 col-lg-6 pb-2">
    <form [formGroup]="form2" *ngIf="showFavorites">

      <app-multi-select-with-service
        *ngIf="_tableDisplayConfig!.tableConfig.id"
        [formControl]="$any(form2.controls.selectedFavorite)"
        (selectedFullModels)="selectedFilterChanged.next($event)"
        [searchOnField]="'title'"
        [reloadEmitter]="reloadFilters"
        [service]="tableFilterFavoriteService"
        [filters]="{'table_id': _tableDisplayConfig!.tableConfig!.id}"
        [inline]="true"
        [small]="true"
        [closeDropDownOnSelection]="true"
        [sort]="'title'"
        [name]="'favorites'"
        [label]="'table_filter.favorites' | translate"
        [selectionMode]="'single_model'"
      ></app-multi-select-with-service>
    </form>
  </div>

  <div class="col-12 col-lg-6 pb-2">
    <div class="d-flex justify-content-end">
      <form *ngIf="_tableDisplayConfig!.tableConfig.id" class="w-100" [formGroup]="form">
        <div class="input-group">
          <div class="input-group">
            <input type="text" [formControl]="form.controls.title" class="form-control" aria-label="Text input with segmented dropdown button">
            <button type="button" (click)="save()" [disabled]="form.controls.title.invalid" class="btn btn-outline-primary" title="{{'table_filter.save_favorite' | translate }}">
              <span class="d-none d-xl-inline">{{'table_filter.save_favorite' | translate }}</span>
              <i class="d-xl-none fa-solid fa-floppy-disk"></i>
            </button>
            <!--            <button type="button" class="btn btn-outline-secondary"><i class="fa-regular fa-bookmark"></i></button>-->
            <button type="button" (click)="deleteFavorite()" *ngIf="form.controls.id.value" class="btn btn-danger"><i class="fa fa-trash"></i></button>
          </div>
        </div>
      </form>

      <div *ngIf="showToggleButtons" class="btn-group btn-group-sm align-self-center justify-self-end ps-3">
        <button type="button" class="btn " [class.btn-outline-secondary]="!showFilters" [class.btn-secondary]="showFilters" (click)="toggleFilter()">
          <i class="fa-solid fa-search-plus"></i>
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="openSorter.next()">
          <i class="fa-solid fa-cogs"></i>
        </button>
      </div>
    </div>
  </div>

</div>
